/**
 * Search all hotels and regions
 * TODO: occasssionally get latest data from server (put time stamp on it. If it's a day old, get fresh)
 * TODO: new memory leak may be present: if we go away and come back many times (when search is cleared and get all again), seems to add memory
 * TODO: consider a client-side fulltext search library like lunr.js (handles stopwords,stemming,tokenization): http://lunrjs.com/
 */
define('controllers/destinations',['require','layout','utils','services/lazydom','cookieutil','controllerManager','rv!templates/booking/destinations'],function(require) {
    'use strict';
    var layout = require('layout');
    var utils = require('utils');
    var LazyDom = require('services/lazydom');
    var cookieutil = require('cookieutil');
    var controllerManager = require('controllerManager');

    var lastVisitedDestination = null;

    return {
        load: function (querystring, data, state) {
            this.state = state;
            this.qs = this._buildQS(querystring);
            this._onAddDestinationsHandler = this._onAddDestinations.bind(this);
            this._onScrollHandler = this._onScroll.bind(this);
            this.$window = $(window);

            var lastSort = utils.getDestinationSort();
            this.state.builtDestinations != null ?
                this._init(this.state.builtDestinations) :
                $.get('/api/destinations/getalldestinations/?sortType={0}'.format(lastSort)).then(function (sortedDestinations) {
                    cookieutil.set('destscroll', 0);
                    $.get('/api/destinations/gettopdestinations').then(function (popularDestinations) {
                        this.state.builtDestinations = this._buildDestinations(popularDestinations, sortedDestinations);
                        this._init(this.state.builtDestinations);
                    }.bind(this));
                }.bind(this));
        },

        _buildQS: function (querystring) {
            var qs = utils.deserializeQs(querystring);
            qs.a = qs.a == null ? [] : qs.a.toString().split(',').map(function (a) { return parseInt(a); });
            return qs;
        },

        _init: function (destinations) {
            this.allDestinations = destinations;
            this.state.builtDestinations = destinations;
            this.ractive = layout.initRactive({
                loading: true,
                loadingNearbyDestinations: false,
                filters: this.qs,
                hasFilters: this._hasFilters,
                contentUrl: window.ServerData.StaticContentUrl,
                destinationSort: utils.getDestinationSort(),
                nearbyMileage: utils.getLastDestinationsMileage()
            }, require('rv!templates/booking/destinations'), {
                twoway: false,
                modifyArrays: false
            });
            this.ractive.on({
                onResetSearch: this._onResetSearch.bind(this),
                getNearbyDestinations: this._getNearbyDestinations.bind(this),
                onSortDestinations: this._sortDestinations.bind(this),
                onSearch: this._onSearch.bind(this),
            });
            this._loadFilter();
            layout.initGlobalHandlers();
            document.title = this.qs.r == null ? 'Destinations' : controllerManager.getCleanTitle(this.qs.r);
        },

        _buildDestinations: function(popularDestinations, sortedDestinations) {            
            popularDestinations = this._setDestinationCards(popularDestinations);
            sortedDestinations = this._setDestinationCards(sortedDestinations);

            return {
                popularDestinations,
                sortedDestinations,
            };
        },

        _setDestinationCards: function(destinations) {
            if (destinations != null && destinations.length > 0) {
                destinations.forEach(function(region) {
                    region.image = this._getRegionImage(region.SmallImage, true);
                    region.imageLarge = this._getRegionImage(utils.isNullOrWhiteSpace(region.LargeImage) ? region.SmallImage : region.LargeImage);
                }.bind(this));
            }
            
            return destinations;
        },

        _getRegionImage: function(imageName, isSmall) {
            var image = isSmall ? 'search/' + imageName : imageName;
            return (utils.isNullOrWhiteSpace(imageName) ? '{0}images/noimage.small.gif' : '{0}images/destinationimages/{1}').format(window.ServerData.StaticContentUrl, window.encodeURIComponent(image)).toLowerCase();
        },

        _loadFilter: function() {
            this.ractive.set('loading', true);
            setTimeout(function() {
                var filtered = this._filter.call(this, this.allDestinations, this.ractive.get('filters')); // this will be update the destinations list or page description
                this._setDestinations(filtered);
            }.bind(this));
        },

        _filter: function (destinations, filters) {
            this._setHrefs(destinations, filters);
            var searchedRegion = !utils.isNullOrWhiteSpace(filters.r);
            var searchPhrase = searchedRegion ? filters.r : filters.s;
            searchPhrase = searchPhrase == null ? null : searchPhrase.toLowerCase();

            var noSearch = utils.isNullOrWhiteSpace(searchPhrase); // reset back to all results
            if (noSearch) {
                lastVisitedDestination = null;
                utils.setLastViewedDestination(null);
                return {
                    popularDestinations: destinations.popularDestinations,
                    sortedDestinations: destinations.sortedDestinations,
                    nearbyDestinations: [], //only show nearby destinations once we have a single region displayed
                };
            } else {
                // This is where our destination details page will load
                var filteredDestinations = destinations.sortedDestinations.filter(function (r) { 
                    return r.RegionName === filters.r; 
                });  // jshint ignore:line

                if (filteredDestinations.length === 1) {
                    var searchType = '';

                    if (lastVisitedDestination !== filteredDestinations[0]) {
                        searchType = utils.getLastViewedDestination() === null ? 'Destination List' : 'Destination Nearby';
                    }

                    lastVisitedDestination = filteredDestinations[0];
                    utils.setLastViewedDestination(lastVisitedDestination);

                    // Save Destination Search
                    this._saveDestinationSearch(searchType);

                    // Set Breadcrumbs
                    this.setBreadCrumbs();

                    var lastSelected = utils.getLastDestinationsMileage();

                    $.get('/api/destinations/getnearbydestinations/?lat={0}&lon={1}&distance={2}'.format(lastVisitedDestination.Latitude, lastVisitedDestination.Longitude, lastSelected)).then(function (nearbyDestinations) {
                        this.ractive.set('loadingNearbyDestinations', true);
                        cookieutil.set('destscroll', 0);
                        this.allDestinations.nearbyDestinations = this._setDestinationCards(nearbyDestinations);
                        this._setHrefs(this.allDestinations);

                        var goto = !this._hasFilters(this.ractive.get('filters')) ? parseInt(cookieutil.get('destscroll')) : 0; //store where they were scrolled to
                        this.ractive.set('loadingNearbyDestinations', false);
                        this.lazyDom = new LazyDom(this.allDestinations.nearbyDestinations, 'destinations.nearbyDestinations', this.ractive, this._onAddDestinationsHandler, goto);
                    }.bind(this));
                }

                return {
                    popularDestinations: [],
                    sortedDestinations: filteredDestinations,
                    nearbyDestinations: this.allDestinations.nearbyDestinations,
                };
            }
        },

        _setHrefs: function (destinations) {
            this._hrefHelper(destinations.popularDestinations);
            this._hrefHelper(destinations.sortedDestinations);
            this._hrefHelper(destinations.nearbyDestinations);
        },

        _hrefHelper: function(destinations) {
            if (destinations != null && destinations.length > 0) {
                destinations.forEach(function(region) {
                    region.href = '/#/destinations/?r={0}'.format(encodeURIComponent(region.RegionName));
                });
            }
        },

        _setDestinations: function (destinations) {
            var noResults = destinations.sortedDestinations.length === 0;
            this.ractive.set('noresults', noResults);
            var filters = this.ractive.get('filters');
            
            this.ractive.set('destinations', null);
            this.ractive.set('destinations.quicksearch', destinations.quicksearch);
            var goto = !this._hasFilters(filters) ? parseInt(cookieutil.get('destscroll')) : 0; //store where they were scrolled to
            this._destroyLazyDom();

            this.ractive.set('destinations.popularDestinations', destinations.popularDestinations);
            this.lazyDom = new LazyDom(destinations.sortedDestinations, 'destinations.sortedDestinations', this.ractive, this._onAddDestinationsHandler, goto);

            this.$window.on('scroll', this._onScrollHandler);
            this.ractive.set('loading', false);

            if (noResults) {
                window.gaTrack('destinations', 'no-results', this._getHashToHere().replace('/destinations/',''), 1);
            }
        },

        _sortDestinations: function () {
            var selection = document.getElementById('sortSelector');

            var selectedChoice = selection.options[selection.selectedIndex].value;
            utils.setDestinationSort(selectedChoice);

            this.getAllDestinations(selectedChoice);
        },

        _getNearbyDestinations: function () {
            this.ractive.set('loadingNearbyDestinations', true);

            var selection = document.getElementById('nearby-mileageSelector');

            var selectedChoice = null;
            if (selection != null && selection.options != null) {
                selectedChoice = selection.options[selection.selectedIndex].value;
                utils.setLastDestinationsMileage(selectedChoice);
            } else {
                selectedChoice = '150';
            }

            var viewed = utils.getLastViewedDestination();

            $.get('/api/destinations/getnearbydestinations/?lat={0}&lon={1}&distance={2}'.format(viewed.Latitude, viewed.Longitude, selectedChoice)).then(function (nearbyDestinations) {
                cookieutil.set('destscroll', 0);
                this.ractive.set('destinations.nearbyDestinations', []);
                this.allDestinations.nearbyDestinations = this._setDestinationCards(nearbyDestinations);

                this._setHrefs(this.allDestinations);

                var goto = !this._hasFilters(this.ractive.get('filters')) ? parseInt(cookieutil.get('destscroll')) : 0; //store where they were scrolled to
                this.ractive.set('loadingNearbyDestinations', false);
                this.lazyDom = new LazyDom(this.allDestinations.nearbyDestinations, 'destinations.nearbyDestinations', this.ractive, this._onAddDestinationsHandler, goto);
            }.bind(this));
        },

        getAllDestinations: function(sortType) {
            $.get('/api/destinations/getalldestinations/?sortType={0}'.format(sortType)).then(function (sortedDestinations) {
                cookieutil.set('destscroll', 0);
                this.state.builtDestinations = this._buildDestinations(this.allDestinations.popularDestinations, sortedDestinations, null);
                this._init(this.state.builtDestinations);
            }.bind(this));
        },

        _onSearch: function() {
            this._saveDestinationSearch('Destination');
            window.location.href = '/#/hotel-new-search';
        },

        _saveDestinationSearch: function(searchType) {
            var destination = utils.getLastViewedDestination();
            
            if (searchType !== '') {
                $.postJSON('/api/destinations/destinationsearch', {
                    Destination: destination,
                    SearchType: searchType
                }).then(function () {
                    return;
                }.bind(this));
            }
        },

        _onScroll: function() {
            if (!this._hasFilters(this.ractive.get('filters'))) {
                cookieutil.set('destscroll', $(window).scrollTop());
            }
        },

        _onAddDestinations: function () {
            if (!this.lazyload) {
                this.lazyload = window.Utilities.lazyLoad();
            } else {
                window.Utilities.lazyLoad().update();
            }
        },

        _onResetSearch: function (e) {
            window.gaTrack('destinations', 'resetbutton', 'click', 1);
            var filters = this.ractive.get('filters');
            this.ractive.set('filters', { v: filters.v, a: [] }); //retain view, but clear everything else
            cookieutil.set('destscroll', 0);
            var hashSame = window.location.hash.replace('#', '') === this._getHashToHere();
            if (hashSame) {
                this._loadFilter();
                return;
            }
            this._loadFilterViaHash();
            utils.setLastViewedDestination(null);
        },

        setBreadCrumbs: function () {
            if (lastVisitedDestination != null) {
                var breadcrumbs = [{
                    name: 'Destinations',
                    url: '/#/destinations'
                }, {
                    name: lastVisitedDestination.RegionName
                }];

                layout.setBreadCrumbs(breadcrumbs);
            }
        },

        _loadFilterViaHash: function() {
            window.location.hash = this._getHashToHere();
        },

        _getHashToHere: function() {
            var filterQs = utils.serializeQs(this.ractive.get('filters'));
            return '/destinations/{0}'.format(filterQs);
        },

        _hasFilters: function(filters) {
            return !utils.isNullOrWhiteSpace(filters.s) ||
                   !utils.isNullOrWhiteSpace(filters.r) ||
                   (Array.isArray(filters.a) && filters.a.length > 0);
        },

        _destroyLazyDom: function() {
            if (this.lazyDom != null) {
                this.lazyDom.destroy();
            }  
        },

        unload: function() {
            if (this.ractive != null) {
                this.ractive.teardown();
            }
            if (this.lazyload != null) {
                this.lazyload.destroy();
            }
            this._destroyLazyDom();
            this.$window.off('scroll', this._onScrollHandler);
            if (this.map != null) {
                this.map.destroy();
            }
            this._cancelAirFareAjax();
            this.map = null;
            this.qs = null;
            this.state = null;
            this.allDestinations = null;
            this._onAddDestinationsHandler = null;
            this._onScrollHandler = null;
            this.lazyload = null;
            this.lazyDom = null;
            this.ractive = null;
            this.$window = null;
        }
    };
});

